import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';

import { map } from 'rxjs/operators';
import { CropAndCropAid } from 'src/app/shared/models';
import { Environment } from 'src/environments/environment.model';

import { LegalRestriction } from '../legal-restriction.model';

@Injectable({
  providedIn: 'root',
})
export class LegalRestrictionApiService {
  protected http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  protected baseUrl = this.env.APIM_BASE_URL + '/arable-service/legal-restriction/';

  getLegalRestriction(cropAidId: number, cropId: number) {
    return this.http.get<LegalRestriction>(
      `${this.baseUrl}cropaidid/${cropAidId}/cropid/${cropId}`,
    );
  }

  getLegalRestrictions(cropAndCropAids: CropAndCropAid[]) {
    return this.http
      .post<{
        legalRestrictions: LegalRestriction[];
      }>(`${this.baseUrl}cropandcropaid`, { cropAndCropAids })
      .pipe(map(({ legalRestrictions }) => legalRestrictions));
  }
}
